// extracted by mini-css-extract-plugin
export var dataCell = "_or-2";
export var dataRow = "_or-0";
export var headerRow = "_or-1";